module.exports = __webpack_public_path__ + "img/comparison.0b069506.png";